// extracted by mini-css-extract-plugin
export default {"pageContainer":"AllDiseasesPage__pageContainer__qn14L","chipsContainer":"AllDiseasesPage__chipsContainer__kcEe9","selectorChip":"AllDiseasesPage__selectorChip__OnE7H","selected":"AllDiseasesPage__selected__A082X","diseasesContainer":"AllDiseasesPage__diseasesContainer__TKgAu","cardContainer":"AllDiseasesPage__cardContainer__ienm3","paginationContainer":"AllDiseasesPage__paginationContainer__HffD9","paginationButton":"AllDiseasesPage__paginationButton__vwsJP"};
    if(module.hot) {
      // 1763020726958
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  